import CreateInvestmentError from './CreateInvestmentError';
class PromotionalCouponDoesNotExists extends CreateInvestmentError {
    constructor(options) {
        super('Promotional coupon does not exist', options);
    }
}
export default PromotionalCouponDoesNotExists;
